import React from 'react'
import { useNavigate } from 'react-router-dom'
import { match } from 'ts-pattern'

import { VerificationMethodCard } from '@frame/ui-components/verification-method-card'

import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { routes } from '@frame/routes'

export function AlternativeMethodsCards() {
  const navigate = useNavigate()
  const { bilEnabledStrategesNoDocuments } = useStrategies()
  const task = useDirectTask()

  function handleClick(strategy: TrueworkJsStrategy) {
    return match(strategy)
      .with(TrueworkJsStrategy.BANK, handleClickBank)
      .with(TrueworkJsStrategy.CREDENTIALS, handleClickCredentials)
      .otherwise(() => null)
  }

  function handleClickBank() {
    navigate(`${routes.bankStatedInformation}/${task?.id}`)
  }

  function handleClickCredentials() {
    if (task?.id) {
      const params = new URLSearchParams()
      params.set('q', task?.employer_name || '')
      navigate(`${routes.companySearch}/${task?.id}?${params.toString()}`)
    } else {
      navigate(routes.companySearch)
    }
  }

  return (
    <>
      {bilEnabledStrategesNoDocuments.map((strategy, idx) => {
        const onClick = () => handleClick(strategy)

        return (
          <VerificationMethodCard
            key={strategy}
            strategy={strategy}
            intent={idx === 0 ? 'primary' : 'secondary'}
            onClick={onClick}
          />
        )
      })}
    </>
  )
}
